<template>
	<v-dialog v-model="dialog" width="420">
		<template v-slot:activator="{ on, attrs }">
			<v-btn icon v-bind="attrs" v-on="on">
				<v-icon color="#374151">mdi-qrcode</v-icon>
			</v-btn>
		</template>

		<v-card rounded="xl" class="pa-2">
			<div class="qr-header">
				<div class="qr-icon-box">
					<v-icon size="18" color="white">mdi-qrcode-scan</v-icon>
				</div>
				<div>
					<p class="qr-title">QR Code de présence</p>
					<p class="qr-subtitle">Scannez pour enregistrer</p>
				</div>
				<v-spacer></v-spacer>
				<v-btn icon small @click="dialog = false">
					<v-icon color="#6b7280">mdi-close</v-icon>
				</v-btn>
			</div>

			<v-divider></v-divider>

			<v-card-text class="text-center py-6">
				<div v-if="!salleId" class="qr-no-salle">
					<v-icon size="40" color="#d1d5db">mdi-domain-off</v-icon>
					<p class="qr-hint mt-3">Sélectionnez une salle pour générer le QR code.</p>
				</div>
				<template v-else>
					<div class="qr-wrapper">
						<img v-if="qrCode" :src="qrCode" alt="QR Code" class="qr-image" />
						<v-progress-circular v-else indeterminate color="#c62828" size="48"></v-progress-circular>
					</div>
					<p class="qr-hint">
						Présentez ce code à l'entrée pour enregistrer votre présence
					</p>
				</template>
			</v-card-text>

			<v-card-actions class="pa-4 pt-0 justify-end">
				<v-btn text color="error" rounded @click="dialog = false">
					Fermer
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import QRCode from "qrcode";
export default {
	props: ["userId"],
	data() {
		return {
			dialog: false,
			qrCode: null,
		};
	},
	computed: {
		salleId() {
			return this.$store.getters.currentVenueId;
		},
	},
	watch: {
		salleId: {
			immediate: true,
			handler(val) {
				if (!val) { this.qrCode = null; return; }
				const opts = {
					errorCorrectionLevel: "H",
					type: "image/jpeg",
					quality: 1,
					color: { dark: "#000000", light: "#FFFFFF" },
				};
				QRCode.toDataURL(JSON.stringify({ salleId: val }), opts)
					.then((url) => { this.qrCode = url; })
					.catch(() => { this.qrCode = null; });
			},
		},
	},
};
</script>

<style scoped>
.qr-header {
	display: flex;
	align-items: center;
	gap: 14px;
	padding: 18px 20px 14px;
}
.qr-icon-box {
	width: 38px;
	height: 38px;
	border-radius: 10px;
	background: linear-gradient(135deg, #c62828, #1565c0);
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
}
.qr-title {
	font-size: 0.92rem;
	font-weight: 700;
	color: #111827;
	margin: 0 0 2px;
	font-family: Montserrat, sans-serif;
}
.qr-subtitle {
	font-size: 0.72rem;
	color: #9ca3af;
	margin: 0;
	font-family: Montserrat, sans-serif;
}
.qr-wrapper {
	display: inline-block;
	padding: 12px;
	background: white;
	border: 2px solid #f3f4f6;
	border-radius: 16px;
	box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
	margin-bottom: 16px;
}
.qr-image {
	width: 200px;
	height: 200px;
	display: block;
	border-radius: 8px;
}
.qr-no-salle {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 4px;
	padding: 16px 0;
}
.qr-hint {
	font-family: Montserrat, sans-serif;
	font-size: 0.75rem;
	color: #6b7280;
	margin: 0;
	max-width: 280px;
	margin-left: auto;
	margin-right: auto;
}
</style>
